import { useState } from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import Main from "../components/Main";
import SignIn from "../components/SignIn";
import CreateNewTask from "../components/CreateNewTask";
import TasksList from "../components/TasksList";
import TaskWithSolutions from "../components/TaskWithSolutions";
import CreateSolutionsToTask from "../components/CreateSolutionsToTask";
import Layout from "../components/Layout";
import Contacts from "../components/Contacts";
import UpdateTask from "../components/UpdateTask";
import UpdateTaskSolutions from "../components/UpdateTaskSolutions";
import FunctionsText from "../components/FunctionsText";
import DomText from "../components/DomText";
import HighPriorityText from "../components/HighPriorityText";
import UserContext from "../context/UserContext";
import PageNotFound from "../components/PageNotFound";
import Tasks from "../components/Tasks";

export default function MainRoutes() {
  const [userData, setUserData] = useState(null);

  return (
    <UserContext.Provider value={{ userData, setUserData }}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route path="/" element={<Main />} />
            <Route path="/tasks" element={<TasksList />} />
            <Route path="/tasks/" element={<Tasks />} />
            <Route path="/tasks/create" element={<CreateNewTask />} />
            <Route
              path="/tasks/Functions"
              element={
                <TasksList section="Functions">
                  <FunctionsText />
                </TasksList>
              }
            />
            <Route
              path="/tasks/dom"
              element={
                <TasksList section="DOM">
                  <DomText />
                </TasksList>
              }
            />
            <Route
              path="/tasks/high-priority"
              element={
                <TasksList section="High-priority">
                  <HighPriorityText />
                </TasksList>
              }
            />
            <Route path="/tasks/update/:uuid" element={<UpdateTask />} />
            <Route
              path="/tasks/update-solutions/:uuid"
              element={<UpdateTaskSolutions />}
            />
            <Route
              path="/tasks/create-solution/:uuid"
              element={<CreateSolutionsToTask />}
            />
            <Route
              path="/tasks/task-with-solutions/:uuid"
              element={<TaskWithSolutions />}
            />
            <Route path="/contacts" element={<Contacts />} />
            <Route path="*" element={<PageNotFound />} />
          </Route>
          <Route path="/signin" element={<SignIn />}></Route>
        </Routes>
      </BrowserRouter>
    </UserContext.Provider>
  );
}
